import { call, put } from "redux-saga/effects";
import Api from "common/api";
import constants from "./constants";

import { resolvePromiseAction, rejectPromiseAction } from "@adobe/redux-saga-promise";

export default {
  GetPerformanceList: function* (data) {
    const __name = constants.GET_PERFORMANCE_LIST;
    try {
      const res = yield call(Api.getPerformanceList, data.cusId, data.date, data.view);
      //console.log("GetPerformanceList", res)
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  GetPerformanceVersus: function* (data) {
    const __name = constants.GET_PERFORMANCE_VERSUS;
    console.log("performance data", data);
    try {
      const result = yield call(Api.getPerformanceVersus, data.cusId, data.baseDate, data.compareDate, data.view);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...result.data });
    } catch (error) {
      console.log("versus error", error);
      yield put({ type: `FETCH_FAILURE_${__name}`, error });
    }
  },
  GetFBDashboard: function* (data) {
    const __name = constants.GET_FBDASHBOARD_LIST;
    try {
      const res = yield call(Api.getFBDashboard, data.ads_account_id, data.date_preset);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  GetFBReport: function* (data) {
    const __name = constants.GET_FBREPORT_LIST;
    try {
      const res = yield call(Api.getFBReport, data.payload.ads_account_id, data.payload.date_preset);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  GetFBGraph: function* (data) {
    const __name = constants.GET_FBGRAPH_LIST;
    try {
      const res = yield call(Api.getFBGraph, data.payload.pixel_code_id, data.payload.date_preset);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  GetGDashboard: function* (data) {
    const __name = constants.GET_GDASHBOARD_LIST;
    try {
      const res = yield call(Api.getGDashboard, data.ads_account_id, data.date_preset);

      const rawCpc = res.data?.cpc;
      const normalizedCpc = rawCpc ? parseFloat(String(rawCpc).replace(/,/g, "")) / 1000000 : rawCpc;

      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data, cpc: normalizedCpc });
    } catch (err) {
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  GetGReport: function* (data) {
    const __name = constants.GET_GREPORT_LIST;
    try {
      const res = yield call(Api.getGReport, data.payload.ads_account_id, data.payload.date_preset);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  GetGGraph: function* (data) {
    const __name = constants.GET_GGRAPH_LIST;
    try {
      const res = yield call(Api.getGGraph, data.payload.ads_account_id, data.payload.date_preset);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
};
